/**
 * Lightweight, zero-dependency helper to detect and reject demo/mock properties.
 * Kept isolated from Firestore SDK to keep public browsing bundles ultra-fast and lean.
 */
export function isDemoProperty(p: any): boolean {
  if (!p) return true;
  const id = String(p.id || '').trim();
  const title = String(p.title || '').trim().toLowerCase();
  const email = String(p.owner_email || p.ownerEmail || '').trim().toLowerCase();
  const ownerId = String(p.owner_id || p.ownerId || '').trim();

  // Demo / Seed IDs — only match explicitly demo-prefixed IDs
  if (
    id.startsWith('prop-demo-') ||
    id.startsWith('prop-test-') ||
    id.startsWith('prop-mock-') ||
    id.startsWith('prop-sample-') ||
    id.startsWith('prop-seed-')
  ) return true;
  if (/^prop-[0-9]{1,2}$/.test(id)) return true;
  if (
    id === 'prop-1789310076197' ||
    id === 'featured-villa-yaounde' ||
    id === 'featured-land-douala' ||
    id === 'featured-apartment-douala' ||
    id === 'prop-1' || id === 'prop-2' || id === 'prop-3' || id === 'prop-4' || id === 'prop-5' ||
    id === 'prop-6' || id === 'prop-7' || id === 'prop-8' || id === 'prop-9' || id === 'prop-10'
  ) return true;

  // Demo Owner IDs
  if (
    ownerId === 'demo-owner-001' ||
    ownerId === 'client-user' ||
    ownerId === 'mock-owner' ||
    ownerId === 'demo-user' ||
    ownerId === 'j72WtkgS6qbf9dEuPpJRCmLQP7x1' ||
    ownerId === '2EDiNiib4Eaz3YsIgExna5gA9Lv1'
  ) return true;

  // Demo / Test Emails
  if (
    email.includes('cameroonlandmark.cm') ||
    email.includes('doualaland.cm') ||
    email.includes('limbe-coast.cm') ||
    email.includes('akwa-commercial.cm') ||
    email.includes('yaoundeprestige.cm') ||
    email.includes('bastos-corporate.cm') ||
    email.includes('wouri-holding.cm') ||
    email.includes('bafoussam-realty.cm') ||
    email.includes('prestige-foncier.cm') ||
    email.includes('bonaberi-land.cm') ||
    email.includes('littoral-properties.cm') ||
    email.includes('buea-realty.cm') ||
    email.includes('golf-residences.cm') ||
    email.includes('kribi-ocean.cm') ||
    email.includes('marina-kribi.cm') ||
    email.includes('limbe-properties.cm') ||
    email.includes('cadastre-cm.com') ||
    email.includes('seller.bastos@') ||
    email.includes('@example.com') ||
    email.includes('@test.com') ||
    email.startsWith('demo@') ||
    email.startsWith('fake@') ||
    email.startsWith('mock@')
  ) {
    return true;
  }

  // Demo Titles (Exact or Partial matches of all demo titles)
  if (
    title.includes('xajxjkkjas') ||
    title.includes('askaskksasal') ||
    title.includes('500sqm land in efoulan') ||
    title.includes('modern 4 bedroom duplex') ||
    title.includes('2 bedroom apartment') ||
    title.includes('furnished studio')
  ) {
    return true;
  }

  return false;
}
